import "awesomplete"
import "./openable-text.js"
import "./recaptcha_controller.js"
import "./rooms-label.js"
import "./scroll-to-error.js"
import "./star_rating_controller.js"
